import { getTypedState } from 'ducks/hooks'

export const getCampaigns = () => (): any => {
  const { campaigns } = getTypedState()
  // if (!orderMaintenance) return null
  return campaigns
}
